import _ from 'lodash'
import Papa from 'papaparse'

import { v4 as uuidv4 } from 'uuid'
import { getAllMaterialGeneticos } from '../services/requests/MaterialGeneticoRequests'
import { getPlantiosPorFazenda } from '../services/requests/PlantioRequests'
import {
	MOTIVO_ARQUIVO_NAO_EH_CSV,
	MOTIVO_ARQUIVO_NAO_EH_TEXTO,
	MOTIVO_ENCODING_NAO_SUPORTADO,
	ReadFileAsText,
} from '../utils/FileManipulation'
import i18n from '../VueI18n'

const mixins = {
	async created() {
		// const res = await getDropdownPlantios()
		// this.plantios = res.map((plantio) => plantio["Código"])

		const matgens = await getAllMaterialGeneticos()
		this.matgens = matgens.data.result
		this.materiaisGeneticos = matgens.data.result.map((matgen) => matgen.mtge_cd_codigo)
	},
	data() {
		return {
			matgens: [],
			/**
			 * Campos que devem ser feito bind para cadastro ou edicao de registro
			 */
			model: {
				id: '',
				cbgm_ds_descricao: '',
				cbgm_dt_afericao: '',
				fk_orsv_ordem_servico: '',
				fk_fzda_fazenda: '',
				fk_mdco_medicao: '',
			},
			ptios: [],
			plantios: [],
			materiaisGeneticos: [],
			colunaAtributo: [],
			colunasMapeamento: [
				{
					nome: i18n.t('section'),
					key: 'talhao',
					descricao: i18n.t('deveConterCodigoTalhao'),
					exemplo: 'T-01',
					formato: 'text',
					regex: new RegExp('t.*lh', 'gi'),
					validator: (value) => {
						return !value ? 'Código do Talhão não pode estar vazio' : null
					},
				},
				{
					nome: i18n.t('plantio'),
					key: 'plantio',
					descricao: i18n.t('deveConterCodigoPlantio'),
					exemplo: 'P-01',
					formato: 'text',
					regex: new RegExp('p.*l.*t', 'gi'),
					validator: (value) => {
						return !value
							? 'Código do Plantio não pode estar vazio'
							: !this.plantios.includes(value)
								? 'Sistema não possui plantio com código: ' + value + ' não será importado'
								: null
					},
				},
				{
					nome: i18n.t('geneticMaterial'),
					key: 'matgen',
					descricao: i18n.t('deveConterValorMateriaGenetico'),
					exemplo: 'H44L',
					formato: 'text',
					regex: new RegExp('m.*t.*r', 'gi'),
					validator: (value) => {
						return !value
							? 'Material Genético não pode estar vazio'
							: !this.materiaisGeneticos.includes(value)
								? 'Sistema não possui Material Genético com código: ' + value
								: null
					},
				},
				{
					nome: i18n.t('age'),
					key: 'idade',
					descricao: i18n.t('deveConterIdadePlantio'),
					exemplo: '10',
					formato: 'number',
					unidade: '(anos)',
					regex: new RegExp('d.*d', 'gi'),
					validator: (value) => {
						value = Number(value.replace(',', '.'))
						return isNaN(value) || value < 0 ? 'Idade deve ser um numero maior que 0' : null
					},
				},
				{
					nome: i18n.t('tree'),
					key: 'arvore',
					descricao: i18n.t('deveConterCodigoArvore'),
					exemplo: '1',
					formato: 'text',
					regex: new RegExp('a.*rv', 'gi'),
					validator: (value) => {
						return !value ? 'Árvore deve ser um valor diferente de nulo' : null
					},
				},
				{
					nome: i18n.t('hbd'),
					key: 'dap',
					descricao: i18n.t('deveConterValorDAP'),
					exemplo: '3,21',
					formato: 'number',
					unidade: '(cm)',
					regex: new RegExp('d.*p', 'gi'),
					validator: (value) => {
						value = Number(value.replace(',', '.'))
						return isNaN(value) || value < 0 ? 'DAP deve ser um numero maior que 0' : null
					},
				},
				{
					nome: i18n.t('ht'),
					key: 'ht',
					descricao: i18n.t('deveConterValorAlturaArvore'),
					exemplo: '3,21',
					formato: 'number',
					unidade: '(m)',
					regex: new RegExp('ht', 'gi'),
					validator: (value) => {
						value = Number(value.replace(',', '.'))
						return isNaN(value) || value < 0 ? 'HT deve ser um numero maior que 0' : null
					},
				},
				{
					nome: i18n.t('sectionDiameter'),
					key: 'dicc',
					descricao: i18n.t('deveConterDiametroSeccao'),
					exemplo: '3,21',
					formato: 'number',
					unidade: '(cm)',
					regex: new RegExp('d.*c', 'gi'),
					validator: (value) => {
						value = value.toString().replace(',', '.')
						const parts = value.split('.')
						const integerPart = parts[0]
						const decimalPart = parts[1] || ''

						if (isNaN(value) || value < 0) {
							return 'DICC deve ser um número maior que 0'
						}

						if (
							integerPart.length + decimalPart.length > 8 ||
							decimalPart.length > 4 ||
							integerPart.length > 4
						) {
							return 'DICC deve ter no máximo 8 dígitos, com no máximo 4 dígitos após a vírgula'
						}

						return null // Se passar nas validações, retorna nulo
					},
				},

				{
					nome: i18n.t('htSeccao'),
					key: 'htSeccao',
					descricao: i18n.t('deveConterAlturaSeccao'),
					exemplo: '3,21',
					formato: 'number',
					unidade: '(m)',
					regex: new RegExp('hi', 'gi'),
					validator: (value) => {
						value = Number(value.replace(',', '.'))
						return isNaN(value) || value < 0
							? 'Altura da secção deve ser um numero maior que 0'
							: null
					},
				},
				{
					nome: i18n.t('shellThickness'),
					key: 'espessuraCasca',
					descricao: i18n.t('deveConterEspessuraDaCasca'),
					exemplo: '3,21',
					formato: 'number',
					unidade: '(cm)',
					regex: new RegExp('sp.*s', 'gi'),
					validator: (value) => {
						value = Number(value.replace(',', '.'))
						return isNaN(value) || value < 0
							? 'Espessura da casca deve ser um numero maior que 0'
							: null
					},
				},
			],
			file: undefined,
			content: { errors: [], data: [] },
			parsed: false,
			/**
			 * Mensagem de falha na leitura do arquivo, antes do parse do CSV.
			 * Fica separada de `content.errors` (que é do Papa) porque o texto
			 * varia: encoding não suportado pede reexportação, erro de leitura
			 * pede nova tentativa.
			 */
			erroLeituraArquivo: '',
		}
	},
	methods: {
		/**
		 * Traduz a falha de leitura do arquivo na orientação correspondente.
		 * Discrimina por `motivo` e não por `instanceof` — ver o comentário do
		 * ArquivoIlegivelError em utils/FileManipulation.
		 *
		 * @param {Error} erro
		 * @returns {string} mensagem já traduzida
		 */
		mensagemErroLeitura(erro) {
			switch (erro?.motivo) {
				case MOTIVO_ENCODING_NAO_SUPORTADO:
					return i18n.t('arquivoEncodingNaoSuportado', { encoding: erro.detalhe })
				case MOTIVO_ARQUIVO_NAO_EH_CSV:
					return i18n.t('arquivoEhPlanilhaNaoCsv')
				case MOTIVO_ARQUIVO_NAO_EH_TEXTO:
					return i18n.t('arquivoNaoEhTexto')
				default:
					// Falha do próprio FileReader (arquivo aberto em outro
					// programa, removido do disco, sem permissão)
					return i18n.t('arquivoNaoPodeSerLido')
			}
		},
		/**
		 * O CSV é lido em texto antes do parse porque o Papa entrega o File
		 * direto ao FileReader, que sempre decodifica como UTF-8: arquivo
		 * exportado do Excel pt-BR (windows-1252) chegava com os acentos
		 * virados em U+FFFD (o "Talhão 1" do arquivo virava "Talh?o 1"), então
		 * o código do plantio nunca batia com o cadastrado e toda linha era
		 * marcada como inconsistente.
		 */
		async parseFile() {
			let conteudo

			this.erroLeituraArquivo = ''

			try {
				conteudo = await ReadFileAsText(this.file)
			} catch (erro) {
				// Nenhum desses casos tem como ser decodificado sem corromper o
				// conteúdo, então diz ao usuário o que corrigir em vez de seguir
				// com a importação e falhar no mapeamento.
				this.erroLeituraArquivo = this.mensagemErroLeitura(erro)
				this.content = { errors: [], data: [] }
				this.parsed = false
				return
			}

			Papa.parse(conteudo, {
				header: true,
				// 'greedy' também descarta linhas só com delimitadores (";;;;"). O Excel
				// exporta assim as linhas vazias formatadas; com `true` uma planilha de
				// 465 medições virava 1 milhão de registros e estourava a memória.
				skipEmptyLines: 'greedy',
				complete: function (results) {
					results.data.forEach((medicao) => {
						medicao.id = uuidv4()
					})
					this.content = results
					this.parsed = true
					this.colunaAtributo = this.autoColunaAtributo
				}.bind(this),
			})
		},
		validaDAP(medicao) {
			const dap = Number(medicao[this.bindColunas.dap].replace(',', '.'))
			const isNan = isNaN(dap)

			if (isNan) {
				medicao.inconsistencias.push('DAP deve ser um número')
			}

			if (!isNan && dap < 0) {
				medicao.inconsistencias.push('DAP deve ser um número maior que 0')
			}
		},
		validaPlantio(medicao) {
			if (!medicao[this.bindColunas.plantio]) {
				medicao.inconsistencias.push('Código do Plantio não pode estar vazio')
			}

			if (!this.plantios.includes(medicao[this.bindColunas.plantio])) {
				medicao.inconsistencias.push(
					'Sistema não possui plantio com código: ' +
						medicao[this.bindColunas.plantio] +
						' não será importado',
				)
			}

			// Verifica se há pelo menos um plantio em comum
			const hasCommonPlantio = this.plantios.some((plantio) => medicao.Plantio.includes(plantio))

			if (hasCommonPlantio) {
				// Se houver pelo menos um plantio em comum, remove todas as inconsistências com a string "A medição não inclui nenhum plantio da fazenda"
				medicao.inconsistencias = medicao.inconsistencias.filter(
					(inconsistencia) => inconsistencia !== 'A medição não inclui nenhum plantio da fazenda',
				)
			}
		},

		validaMaterialGenetico(medicao) {
			if (!medicao[this.bindColunas.matgen]) {
				medicao.inconsistencias.push('Código do Material Genético não pode estar vazio')
			}

			if (!this.materiaisGeneticos.includes(medicao[this.bindColunas.matgen])) {
				medicao.inconsistencias.push(
					'Sistema não possui Material Genético com código: ' + medicao[this.bindColunas.matgen],
				)
			}
		},
		validaArvore(medicao) {
			if (!medicao[this.bindColunas.arvore]) {
				medicao.inconsistencias.push('Árvore deve ser um valor válido')
			}
		},
		validaDap(medicao) {
			if (isNaN(medicao[this.bindColunas.dap].replace(',', '.'))) {
				medicao.inconsistencias.push('DAP deve ser um número')
			} else if (medicao[this.bindColunas.dap] < 0) {
				medicao.inconsistencias.push('DAP deve ser um número maior que 0')
			}
		},
		validaDicc(medicao) {
			const diccRegex = /^\d{1,4}(?:\.\d{1,4})?$/ // Regex para até 4 dígitos antes e até 4 dígitos após a vírgula
			if (!diccRegex.test(medicao[this.bindColunas.dicc].replace(',', '.'))) {
				medicao.inconsistencias.push(
					'DICC deve ser um número com no máximo 8 dígitos, sendo 4 no máximo após a vírgula',
				)
			}

			if (isNaN(medicao[this.bindColunas.dicc].replace(',', '.'))) {
				medicao.inconsistencias.push('DICC deve ser um número')
			} else if (medicao[this.bindColunas.dap] < 0) {
				medicao.inconsistencias.push('DICC deve ser um número maior que 0')
			}
		},
		validaHt(medicao) {
			if (isNaN(medicao[this.bindColunas.ht].replace(',', '.'))) {
				medicao.inconsistencias.push('HT deve ser um número')
			} else if (medicao[this.bindColunas.dap] < 0) {
				medicao.inconsistencias.push('HT deve ser um número maior que 0')
			}
		},
		validaEspessuraCasca(medicao) {
			if (isNaN(medicao[this.bindColunas.espessuraCasca].replace(',', '.'))) {
				medicao.inconsistencias.push('Espessura da Casca deve ser um número')
			} else if (medicao[this.bindColunas.espessuraCasca] < 0) {
				medicao.inconsistencias.push('Espessura da Casca deve ser um número maior que 0')
			}
		},
		validaAlturaSeccao(medicao) {
			if (isNaN(medicao[this.bindColunas.htSeccao].replace(',', '.'))) {
				medicao.inconsistencias.push('Altura da Secção deve ser um número')
			} else if (medicao[this.bindColunas.htSeccao] < 0) {
				medicao.inconsistencias.push('Altura da Secção deve ser um número')
			}
		},
		validaIdade(medicao) {
			if (isNaN(medicao[this.bindColunas.idade].replace(',', '.'))) {
				medicao.inconsistencias.push('Idade deve ser um número')
			} else if (medicao[this.bindColunas.idade] < 0) {
				medicao.inconsistencias.push('Idade deve ser um número')
			}
		},
		validaMedicoes(medicoes) {
			medicoes.forEach((medicao) => {
				medicao.inconsistencias = []
				medicao.insights = []
				this.validaDAP(medicao)
				this.validaPlantio(medicao)
				this.validaArvore(medicao)
				this.validaDap(medicao)
				this.validaDicc(medicao)
				this.validaHt(medicao)
				this.validaEspessuraCasca(medicao)
				this.validaAlturaSeccao(medicao)
				this.validaIdade(medicao)
				this.validaMaterialGenetico(medicao)
			})
		},
	},
	computed: {
		medicoesPreparadas() {
			return Object.keys(this.medicoesAgrupadasPorPlantio).map((m) => {
				return this.medicoesAgrupadasPorPlantio[m].map((medicao) => {
					return {
						plantioId: this.ptios.find(
							(plantio) => plantio.ptio_cd_codigo === medicao[this.bindColunas.plantio],
						).id,
						materialGeneticoId: this.matgens.find(
							(material) => material.mtge_cd_codigo === medicao[this.bindColunas.matgen],
						).id,
						codigoDoPlantio: medicao[this.bindColunas.plantio],
						idadePlantio: medicao[this.bindColunas.idade],
					}
				})
			})
		},
		/**
		 * Agrupa medições por plantio
		 * @returns {Object} medições agrupadas por plantio
		 */
		medicoesAgrupadasPorPlantio() {
			return _.groupBy(this.medicoesNormalizadas, this.bindColunas.plantio)
		},
		medicoesAgrupadasPorPlantioArvore() {
			const group = []
			Object.keys(this.medicoesAgrupadasPorPlantio).forEach((plantio) => {
				let arvores = _.groupBy(this.medicoesAgrupadasPorPlantio[plantio], this.bindColunas.arvore)
				group.push({
					plantio: {
						id: this.ptios.find((p) => p.ptio_cd_codigo === plantio).id,
						codigo: plantio,
					},
					arvores,
				})
			})
			return group
		},
		medicoesAgrupadasPorPlantioArvoreSeccao() {
			return this.medicoesAgrupadasPorPlantioArvore.map((m) => {
				let arvores = []
				let materialGeneticoId = ''
				let idadeDoPlantio = ''
				let codigosArvore = Object.keys(m.arvores)
				codigosArvore.forEach((ca) => {
					materialGeneticoId = this.matgens.find(
						(matgen) => matgen.mtge_cd_codigo === m.arvores[ca][0][this.bindColunas.matgen],
					).id

					arvores.push({
						codigoArvore: m.arvores[ca][0][this.bindColunas.arvore],
						DAP: Number.parseFloat(m.arvores[ca][0][this.bindColunas.dap].replace(',', '.')),
						altura: Number.parseFloat(m.arvores[ca][0][this.bindColunas.ht].replace(',', '.')),
						seccoes: m.arvores[ca].map((arvore) => {
							return {
								alturaDaSeccao: Number.parseFloat(
									arvore[this.bindColunas.htSeccao].replace(',', '.'),
								),
								diametroDaSeccao: Number.parseFloat(
									arvore[this.bindColunas.dicc].replace(',', '.'),
								),
								espessuraDaCasca: Number.parseFloat(
									arvore[this.bindColunas.espessuraCasca].replace(',', '.'),
								),
								idade: Number.parseInt(arvore[this.bindColunas.idade]),
							}
						}),
					})
				})

				return {
					plantioId: m.plantio.id,
					codigoPlantio: m.plantio.codigo,
					materialGeneticoId,
					idadeDoPlantio,
					arvores,
				}
			})
		},
		bindColunas() {
			return Object.fromEntries(this.colunaAtributo.map((ca) => [ca.value, ca.key]))
		},
		/**
		 * Trata os dados das medições para facilitar a análise, adiciona atributos importantes, converte dados, etc...
		 * @returns Lista de medições normalizada
		 */
		medicoesNormalizadas() {
			const data = this.content.data || []
			return data.map((medicao) => {
				return Object.assign(medicao, {
					inconsistencias: [],
					insights: [],
					desconsiderar: false,
				})
			})
		},
		autoColunaAtributo() {
			return this.colunasMapeamento.map((coluna) => {
				return {
					coluna: coluna.nome,
					value: coluna.key,
					key:
						Object.keys(this.content.data[0])
							.map((m) => {
								return { value: m, label: m }
							})
							.find((f) => new RegExp(coluna.regex).test(f.label))?.label ||
						Object.keys(this.content.data[0])[0],
				}
			})
		},
	},
	watch: {
		'model.fk_fzda_fazenda': {
			handler(valor) {
				console.log(valor)
				getPlantiosPorFazenda(valor).then((res) => {
					this.ptios = res.data
					this.plantios = res.data.map((m) => m.ptio_cd_codigo)
				})
			},
		},
		medicoesNormalizadas: {
			handler(value) {
				this.validaMedicoes(value)
			},
			deep: true,
		},
		bindColunas: {
			handler() {
				this.validaMedicoes(this.medicoesNormalizadas)
			},
		},
	},
}

export default mixins
